import * as React from "react";

import {
  MotorcycleProductDetailsFormValues,
  MotorcycleTexts,
} from "../motorcycleInterface";

import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import InsuranceOwnerFormElements from "Components/Form/CommonFormElements/InsuranceOwnerFormElement";
import { RadioButtonTrueFalse } from "Components/Form/RadioButton";
import { RecentDamages } from "Components/Form/RecentDamages";
import { Select } from "Components/Form/Select";
import { TextLanguage } from "Store/texts/interfaces";
import { useUserIdentificationSelector } from "Store/userIdentification/userIdentificationSelectors";
import { isDefined } from "Utils/functions";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import { getUsabilityCodeOptions } from "../motorcycleUtils/formElementsOptions";

interface Props {
  readonly formProps: FormikProps<MotorcycleProductDetailsFormValues>;
  readonly texts: MotorcycleTexts["formText"]["checkPrice"];
  readonly lang: TextLanguage;
}

export const FormElements = (props: Props): React.ReactElement => {
  const { formProps, texts, lang } = props;
  const userIdentification = useUserIdentificationSelector();
  const customerAge = userIdentification?.newCustomerResponse.age;

  return (
    <>
      <InsuranceOwnerFormElements
        formProps={formProps}
        formText={texts}
        lang={lang}
      />
      <Select
        large
        id="usabilityCode"
        name="usabilityCode"
        label={texts.usabilityCode.label[lang]}
        options={getUsabilityCodeOptions(
          texts.usabilityCode.options,
          lang,
          isDefined(customerAge) ? Number(customerAge) : 99,
        )}
        error={getError("usabilityCode", formProps)}
      />
      <RadioButtonTrueFalse
        name="mortgagee"
        id="mortgagee"
        hint={texts.mortgagee.hint[lang]}
        label={texts.mortgagee.label[lang]}
        options={[
          {
            label: texts.mortgagee.options.yes[lang],
            value: true,
            id: "yes",
          },
          {
            label: texts.mortgagee.options.no[lang],
            value: false,
            id: "no",
          },
        ]}
        direction="vertical"
        error={getError("mortgagee", formProps)}
      />
      <RadioButtonTrueFalse
        name="mcLocker"
        id="mcLocker"
        hint={texts.mcLocker.hint[lang]}
        label={texts.mcLocker.label[lang]}
        options={[
          {
            label: texts.mcLocker.options.yes[lang],
            value: true,
            id: "mcLocker-yes",
          },
          {
            label: texts.mcLocker.options.no[lang],
            value: false,
            id: "mcLocker-no",
          },
        ]}
        direction="vertical"
        error={getError("mcLocker", formProps)}
      />
      <RadioButtonTrueFalse
        name="garage"
        id="garage"
        hint={texts.garage.hint[lang]}
        label={texts.garage.label[lang]}
        options={[
          {
            label: texts.garage.options.yes[lang],
            value: true,
            id: "garage-yes",
          },
          {
            label: texts.garage.options.no[lang],
            value: false,
            id: "garage-no",
          },
        ]}
        direction="vertical"
        error={getError("garage", formProps)}
      />
      <RecentDamages
        formProps={formProps}
        productName={ProductBackendName.MOTORCYCLE}
      />
    </>
  );
};
